import React from "react";

export default function Header() {
  return (
    <header className="gds-spa-header" style={{ height: 35 }}>
      <div className="gds-spa-header__primary-nav">
        <div className="gds-spa-header__section gds-spa-header__section-icon">
          <img
            className="gds-spa-header__logo-mark"
            src="https://gumgum-design-system.s3.amazonaws.com/mark.svg"
            alt="logo"
          />
        </div>
        <div className="gds-spa-header__section gds-spa-header__section--product">
          <div className="gds-page-header__product-name">Ad Builder</div>
        </div>
      </div>

      <div className="gds-spa-header__secondary-nav">
        <div className="gds-spa-header__section">
          <div className="gds-text--body-xs gds-text--bold -text-tr-up ">
            Account
          </div>
        </div>
        <div className="gds-spa-header__section gds-spa-header__section-icon">
          <div className="gds-spa-header__section-link" role="button">
            <i className="fa fa-user"></i>
          </div>
        </div>
      </div>
    </header>
  );
}
